module.exports = __webpack_public_path__ + "aab5b48cf457b0979d7c3a03261ccbc5.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/plus_circle_24.svg
// module id = 1364
// module chunks = 74